import { render, staticRenderFns } from "./BarWithCategoryNameAndLabelInside.vue?vue&type=template&id=4b59be3e&scoped=true&"
import script from "./BarWithCategoryNameAndLabelInside.vue?vue&type=script&lang=js&"
export * from "./BarWithCategoryNameAndLabelInside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b59be3e",
  null
  
)

export default component.exports